// Responsive layout hook using Tailwind standard breakpoints
// CREATED: Standardized responsive behavior aligned with Tailwind's md breakpoint (768px)
// Replaces the obsolete useViewport hook which used an inconsistent 1024px breakpoint
// Used by: RoleBasedLayout and all components requiring responsive behavior

import { useState, useEffect } from 'react';

// Tailwind standard breakpoint: md = 768px
const DESKTOP_BREAKPOINT = 768;

export function useResponsiveLayout() {
  const [isDesktop, setIsDesktop] = useState(
    () => window.innerWidth >= DESKTOP_BREAKPOINT
  );

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    };

    // Use ResizeObserver for better performance if available
    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(document.documentElement);
      return () => resizeObserver.disconnect();
    }

    // Fallback to resize event
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isDesktop,
    isMobile: !isDesktop,
    breakpoint: DESKTOP_BREAKPOINT
  };
}
